import axios from "axios";
import { createEffect } from "effector";
import { empty, unpackServerData } from "../../../common/functions";
import { getUuidAndSession } from "../../../common/localStorage";
import { IQueryGetPaymentsNew } from "./types"

export const queryGetPaymentsNew = createEffect<IQueryGetPaymentsNew, void>();

queryGetPaymentsNew.use(({accountId, setPayments, setFailMsg, setLoading}: IQueryGetPaymentsNew) =>
// axios.post("https://izba.kras-abs.ru/api/v2/getPaymentsNew", {
  axios.post("https://izba.kras-abs.ru/api/v3/pay/list", {
    ...getUuidAndSession(),
    accountId: accountId,
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }
    }).then((resp) => {
      let {data, failMsg} = unpackServerData(resp.data, "getPayments.debt")
      setPayments(failMsg != "" ? {debt: [], pays: []} : {debt: data, pays: []})
      setFailMsg(failMsg != ""? "" : failMsg)
      setLoading(false)
    }).catch(e => {
      let msg = e.message
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          msg = data.failMsg
        }
      }
      setPayments({debt: [], pays: []})
      // setPayments({"debt":
      // ["2019-06","2019-11","2020-01","2020-02","2020-03","2020-04","2020-05","2020-06","2020-07","2020-08","2020-09","2020-10","2020-11"],
      // "pays":[]})
      setFailMsg(msg)
      setLoading(false)
    })
);


export function getPaymentFileAndDownload(accountNum: string, period: string, errMsg: (err: string) => void) {
  axios.post("https://izba.kras-abs.ru/api/v2/getPaymentFile", { // не используется
    ...getUuidAndSession(),
    accountNum: accountNum,
    period: period
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }
    }).then((resp) => {
      console.log(resp)
      let {data, failMsg} = unpackServerData(resp.data, "getPaymentFile")
      if(failMsg == "" && !empty(data['message'])) {
        failMsg = data['message']
        console.log(failMsg)
      } else if (!empty(data['url'])) {
        data = data['url']
      }
      if(failMsg != "") errMsg(failMsg)
      else window.open(data, "_blank")
    }).catch(e => {
      let msg = e.message
      console.log(msg)
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          msg = data.failMsg
         
        }
      }
      errMsg(msg)
    })
}